import { Link } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid-pro';
import { FC } from 'react';

import { formatName } from '../../../components/formatUtils';
import { formatDate } from '../../../components/formatUtils/dateFormatUtils';
import { AppDataGrid } from '../../../components/table/AppDataGrid';
import { useFindAllMitarbeiterQuery } from '../api/mitarbeiterApi';
import { Aktivitaetsstatus, Mitarbeiter } from '../api/types';

export const mitarbeiterTableColumns: GridColDef[] = [
  {
    field: 'kuerzel',
    headerName: 'Kürzel',
    flex: 1,
  },
  {
    field: 'name',
    headerName: 'Name',
    flex: 2,
    valueGetter: (value, row) => formatName(row as Mitarbeiter),
  },
  {
    field: 'user.email',
    headerName: 'Email',
    flex: 2,
    valueGetter: (value, row) => (row as Mitarbeiter).email,
    renderCell: params => (
      <Link onClick={e => e.stopPropagation()} href={`mailto:${(params.row as Mitarbeiter).email}`}>
        {(params.row as Mitarbeiter).email}
      </Link>
    ),
  },
  {
    field: 'user.role',
    headerName: 'Rolle',
    flex: 1,
    valueGetter: (value, row) => (row as Mitarbeiter).role,
  },
  {
    field: 'Aktivitätsstatus',
    headerName: 'Aktivitätsstatus',
    flex: 1,
    valueGetter: (value, row) => (row as Mitarbeiter).aktivitaetsstatus,
  },
  {
    field: 'creationDate',
    headerName: 'Angelegt am',
    flex: 1,
    type: 'date',
    valueFormatter: value => formatDate(value as string),
  },
];

export const MitarbeiterTable: FC = () => {
  const { data: mitarbeiter = [], isFetching } = useFindAllMitarbeiterQuery();

  return (
    <AppDataGrid
      checkboxSelection={true}
      loading={isFetching}
      columns={mitarbeiterTableColumns}
      rows={mitarbeiter}
      initialState={{
        filter: {
          filterModel: {
            items: [
              { field: 'Aktivitätsstatus', operator: 'equals', value: Aktivitaetsstatus.AKTIV },
            ],
          },
        },
      }}
    />
  );
};
